(function() {
  var fixInterval = null;
  var fixTimeout = null;
  var drawer = null;
  var codGuardTimer = null;
  var codGuardInterval = null;
  var COD_MINIMUM_SUBTOTAL = 2500;
  var COD_FORM_SELECTOR = '#rsi_form_wrapper[open]';
  var COD_LINE_SELECTOR = '.rsi-product-item-wrapper';
  var COD_SUBMIT_SELECTOR = '[data-rsi-cod-button="true"], .rsi-submit_button';
  var COD_WARNING_ID = 'icia-rsi-sample-minimum';

  function ensureModalContainerStyle() {
    if (document.getElementById('icia-releasit-modal-container')) return;
    var style = document.createElement('style');
    style.id = 'icia-releasit-modal-container';
    style.textContent = 'html[data-rsi-cart-total-out-of-range="false"]:not([data-rsi-cart-total-validating="true"]):not([data-rsi-cart-product-excluded="true"]) ._rsi-buy-now-button-app-block-hook:has(#rsi_form_wrapper[open]) { display: block !important; }'
      + '#'+COD_WARNING_ID+'{margin:10px 0;padding:10px 12px;border:1px solid #b42318;border-radius:8px;background:#fff4f2;color:#8a1c13;font-size:14px;font-weight:700;line-height:1.35;text-align:center}'
      + COD_FORM_SELECTOR+' '+COD_SUBMIT_SELECTOR+'[data-icia-sample-guard="true"]{cursor:not-allowed!important;opacity:.55!important;}';
    document.head.appendChild(style);
  }

  function normalizedFormat(value) {
    return String(value || '').replace(/\s+/g, '').toLowerCase();
  }

  function priceInCents(value) {
    var raw = String(value || '').replace(/[^0-9.,]/g, '');
    if (!raw) return NaN;
    var separator = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
    var decimals = separator >= 0 ? raw.length - separator - 1 : 0;
    if (separator >= 0 && decimals > 0 && decimals <= 2) {
      var whole = raw.slice(0, separator).replace(/[^0-9]/g, '');
      var fraction = raw.slice(separator + 1);
      return Number(whole || '0') * 100 + Number((fraction + '00').slice(0, 2));
    }
    return Number(raw.replace(/[^0-9]/g, '')) * 100;
  }

  function codFormState(form) {
    var lines = Array.prototype.slice.call(form.querySelectorAll(COD_LINE_SELECTOR));
    if (!lines.length) return { ready: false, blocked: false, remaining: 0 };
    var sampleOnly = lines.every(function(line) {
      var format = line.querySelector('.rsi-product-item-subtitle');
      return normalizedFormat(format && format.textContent) === '2ml';
    });
    var summary = Array.prototype.slice.call(form.querySelectorAll('.rsi-total-summary-line-item'));
    var subtotalLine = summary.find(function(line) {
      var label = line.querySelector('.rsi-total-summary-label');
      return /^(TOTALE PARZIALE|SUBTOTALE|SUBTOTAL)$/i.test(String(label && label.textContent || '').trim());
    });
    var subtotalValue = subtotalLine && subtotalLine.querySelector('.rsi-total-summary-value');
    var subtotal = priceInCents(subtotalValue && subtotalValue.textContent);
    return {
      ready: true,
      blocked: sampleOnly && (!Number.isFinite(subtotal) || subtotal < COD_MINIMUM_SUBTOTAL),
      remaining: Number.isFinite(subtotal) ? Math.max(0, COD_MINIMUM_SUBTOTAL - subtotal) : null,
      subtotal: subtotal
    };
  }

  function codWarningText(remaining) {
    var italian = String(document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;
    var message = italian
      ? 'Ordini di soli campioncini: minimo 25 € prima degli sconti.'
      : 'Sample-only orders: minimum €25 before discounts.';
    if (!Number.isFinite(remaining) || remaining <= 0) return message;
    var amount = new Intl.NumberFormat(italian ? 'it-IT' : 'en-IE', { style: 'currency', currency: 'EUR' }).format(remaining / 100);
    return message + (italian ? ' Importo mancante: ' : ' Amount remaining: ') + amount + '.';
  }

  function applyCodSampleGuard() {
    var form = document.querySelector(COD_FORM_SELECTOR);
    if (!form) return null;

    var state = codFormState(form);
    var submit = form.querySelector(COD_SUBMIT_SELECTOR);
    var warning = form.querySelector('#' + COD_WARNING_ID);

    if (!state.ready || !submit) return state;

    if (state.blocked) {
      if (!submit.hasAttribute('data-icia-sample-guard')) {
        submit.setAttribute('data-icia-sample-previous-disabled', String(Boolean(submit.disabled)));
      }
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      submit.setAttribute('data-icia-sample-guard', 'true');

      if (!warning) {
        warning = document.createElement('p');
        warning.id = COD_WARNING_ID;
        warning.setAttribute('role', 'alert');
        warning.setAttribute('aria-live', 'assertive');
        submit.parentNode.insertBefore(warning, submit);
      }
      var message = codWarningText(state.remaining);
      if (warning.textContent !== message) warning.textContent = message;
    } else {
      if (warning) warning.remove();
      if (submit.getAttribute('data-icia-sample-guard') === 'true') {
        if (submit.getAttribute('data-icia-sample-previous-disabled') === 'false') {
          submit.disabled = false;
          submit.setAttribute('aria-disabled', 'false');
        }
        submit.removeAttribute('data-icia-sample-guard');
        submit.removeAttribute('data-icia-sample-previous-disabled');
      }
    }

    return state;
  }

  function scheduleCodSampleGuard(delay) {
    if (codGuardTimer) clearTimeout(codGuardTimer);
    codGuardTimer = setTimeout(function() {
      codGuardTimer = null;
      applyCodSampleGuard();
    }, typeof delay === 'number' ? delay : 50);
  }

  function blockInvalidCodSubmit(event) {
    var submit = event.target.closest && event.target.closest(COD_SUBMIT_SELECTOR);
    if (!submit || !submit.closest(COD_FORM_SELECTOR)) return;
    var state = applyCodSampleGuard();
    if (!state || !state.blocked) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    var warning = document.getElementById(COD_WARNING_ID);
    if (warning) warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initCodSampleGuard() {
    try {
      window.iciaCodSampleGuard = Object.freeze({
        minimumSampleSubtotal: COD_MINIMUM_SUBTOTAL,
        state: codFormState,
        apply: applyCodSampleGuard
      });
    } catch (error) {
      // Some privacy-focused browsers expose a non-extensible window object.
    }

    document.addEventListener('click', function(event) {
      blockInvalidCodSubmit(event);
      if (event.target.closest && event.target.closest(COD_FORM_SELECTOR + ' .rsi-product-item-quantity-controls, ' + COD_FORM_SELECTOR + ' .rsi-product-item-remove')) {
        scheduleCodSampleGuard(120);
      }
      if (event.target.closest && event.target.closest('#rsi_buy_now_button, .rsi_buy_now_button')) {
        scheduleCodSampleGuard(250);
      }
    }, true);

    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form.closest || !form.closest(COD_FORM_SELECTOR)) return;
      var state = applyCodSampleGuard();
      if (!state || !state.blocked) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);

    document.addEventListener('input', function(event) {
      if (event.target.matches && event.target.matches(COD_FORM_SELECTOR + ' .rsi-quantity-input')) {
        scheduleCodSampleGuard(0);
      }
    }, true);

    document.addEventListener('change', function(event) {
      if (event.target.matches && event.target.matches(COD_FORM_SELECTOR + ' .rsi-quantity-input')) {
        scheduleCodSampleGuard(0);
      }
    }, true);

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function(mutations) {
        if (mutations.some(function(mutation) {
          return mutation.type === 'characterData' || mutation.addedNodes.length || mutation.removedNodes.length;
        })) {
          scheduleCodSampleGuard(30);
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } else if (!codGuardInterval) {
      codGuardInterval = setInterval(applyCodSampleGuard, 250);
    }

    scheduleCodSampleGuard(0);
  }

  function getOverlay() {
    return document.getElementById('CartDrawer-Overlay');
  }

  function clearFixTimers() {
    if (fixInterval) {
      clearInterval(fixInterval);
      fixInterval = null;
    }
    if (fixTimeout) {
      clearTimeout(fixTimeout);
      fixTimeout = null;
    }
  }

  function removeInlineOverlayDisplay() {
    var overlay = getOverlay();
    if (overlay) overlay.style.removeProperty('display');
  }

  function restoreOpenState() {
    removeInlineOverlayDisplay();
    if (drawer && drawer.classList.contains('active')) {
      document.body.classList.add('overflow-hidden');
    }
  }

  function finishFix() {
    clearFixTimers();
    removeInlineOverlayDisplay();
  }

  function fixOverlay() {
    if (!drawer || drawer.classList.contains('active')) {
      finishFix();
      restoreOpenState();
      return;
    }

    var overlay = getOverlay();
    if (overlay) overlay.style.setProperty('display', 'none', 'important');

    document.body.classList.remove('overflow-hidden');
  }

  function startFix() {
    clearFixTimers();
    fixOverlay();
    fixInterval = setInterval(fixOverlay, 50);
    fixTimeout = setTimeout(finishFix, 3000);
  }

  function init() {
    ensureModalContainerStyle();
    initCodSampleGuard();
    drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName !== 'class') return;

          if (drawer.classList.contains('active')) {
            finishFix();
            restoreOpenState();
          } else {
            startFix();
          }
        });
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
